import { fetchCompanyContactData } from '../api/company.api'
import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import { CompanyContactData } from 'src/Libs/user/models'
import { usePortalQuery } from 'src/Libs/api'

type DataReturnType = [CompanyContactData | undefined, () => void, boolean, boolean]

/**
 * Hook to query company location
 */
export const useFetchCompanyLocation = (companyId: string | number | undefined): DataReturnType => {
  const authFetch = useAuthFetchWithResponse()

  const fetchCompanyContactDataQueryFn = async (): Promise<CompanyContactData | null> => {
    const companyIdAsNumber = typeof companyId === 'string' ? parseInt(companyId) : companyId

    const { error, hasErrors, value } = await fetchCompanyContactData(companyIdAsNumber, authFetch)

    if (hasErrors) {
      throw error || new Error('An unexpected error occurred when fetching company location')
    }

    return value
  }

  const { data, isLoading, isError, refetch } = usePortalQuery({
    queryKey: ['users', 'companies', companyId, 'location'],
    queryFn: fetchCompanyContactDataQueryFn,
    enabled: !!companyId,
  })

  return [data || undefined, refetch, isLoading, isError]
}
